import React from 'react';

type UnsupportedVizPlaceholderProps = {
  vizType: string;
  title: string;
};

export function UnsupportedVizPlaceholder({ vizType, title }: UnsupportedVizPlaceholderProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-muted/20 p-8 text-center">
      <svg
        className="mb-3 h-10 w-10 text-muted-foreground/50"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h18" />
        <path d="M9 21V9" />
      </svg>
      <p className="text-sm font-medium text-muted-foreground">{title}</p>
      <p className="mt-1 text-xs text-muted-foreground/70">
        Visualization type &quot;{vizType}&quot; is not yet supported
      </p>
    </div>
  );
}
